import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import { UpdatePortalSignInPasswordRequest } from "../contracts/UpdatePortalSignInPasswordRequest";
import { SignInPasswordStateResponse } from "../contracts/SignInPasswordStateResponse";
import portalAxios from "../portalAxios";

/** Whether the signed-in person's sign-in has a password yet (US-113, PD-0056). */
export const fetchSignInPasswordState = createAsyncThunk<
  SignInPasswordStateResponse,
  void,
  { rejectValue: ApiErrorResponse }
>("portal/fetchSignInPasswordState", async (_, { rejectWithValue }) => {
  try {
    const response = await portalAxios.get<SignInPasswordStateResponse>("/portal/me/sign-in-password");
    return response.data;
  } catch (error) {
    return rejectWithValue(toApiError(error));
  }
});

/** Sets or changes the signed-in person's own sign-in password; the person comes from the portal token. */
export const saveSignInPassword = createAsyncThunk<void, UpdatePortalSignInPasswordRequest, { rejectValue: ApiErrorResponse }>(
  "portal/saveSignInPassword",
  async (request, { rejectWithValue }) => {
    try {
      await portalAxios.put("/portal/me/sign-in-password", request);
    } catch (error) {
      return rejectWithValue(toApiError(error));
    }
  },
);
